<template>
  <div class="details-execution">
    <h3 class="intern-title ml-3">
      <back-arrow />
      <span class="page-nav">{{ $t("execution") }}:</span>
      <span class="page-nav">{{ $t("material") }}</span>
    </h3>

    <div class="details-info ml-3">
      <div class="details-numbers">
        <div class="card-widget">
          <div class="img-border">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.17206 15.2773L4.96016 13.969C4.61456 13.5959 4.03195 13.5736 3.65886 13.9192L3.53659 14.0325C3.1635 14.3781 3.14122 14.9607 3.48683 15.3338L4.69873 16.6421C5.04433 17.0152 5.62694 17.0374 6.00003 16.6918L6.1223 16.5786C6.49539 16.233 6.51767 15.6504 6.17206 15.2773Z"
                fill="#BEDB74"
              />
              <path
                d="M16.5625 12.5C18.461 12.5 20 10.961 20 9.0625C20 7.16402 18.461 5.625 16.5625 5.625C14.664 5.625 13.125 7.16402 13.125 9.0625C13.125 10.961 14.664 12.5 16.5625 12.5Z"
                fill="#A47AA9"
              />
              <path
                d="M7.16667 18.775C7.77227 18.8145 8.38018 18.8005 8.98333 18.7333L9.58333 18.6375H9.61667C12.8625 18.0125 15.375 16.1375 17.0875 13.1041C18.7542 10.1333 18.9292 6.75831 17.6 2.78747C17.5055 2.43558 17.3233 2.11339 17.0705 1.85106C16.8176 1.58873 16.5024 1.39482 16.1542 1.28747C15.7955 1.2131 15.4238 1.23106 15.074 1.33965C14.7242 1.44824 14.4077 1.64391 14.1542 1.90831C13.3827 2.673 12.3842 3.16712 11.3083 3.31664C10.1375 3.45831 8.95 3.52497 7.80417 3.59164H7.56667C6.25772 3.60041 4.97062 3.9279 3.81667 4.54581C0.645833 6.43331 -1.25 10.525 1.25 14.7041C1.31097 14.8039 1.36391 14.9084 1.40833 15.0166L1.52917 15.3125L1.35417 15.575C0.899538 16.2746 0.482287 16.9979 0.104167 17.7416C0.0898919 17.773 0.0825063 17.8071 0.0825063 17.8416C0.0825063 17.8761 0.0898919 17.9102 0.104167 17.9416C0.113888 17.9743 0.130425 18.0046 0.152687 18.0305C0.17495 18.0563 0.202435 18.0772 0.233333 18.0916C0.263657 18.1075 0.296818 18.1171 0.330894 18.12C0.36497 18.1229 0.399283 18.119 0.431841 18.1085C0.4644 18.0981 0.494556 18.0812 0.520561 18.059C0.546567 18.0368 0.567903 18.0097 0.583333 17.9791C1.32307 16.5102 2.23202 15.1328 3.29167 13.875L3.70833 13.3791L4.16667 13.8458C4.4 14.0833 4.69167 14.3875 4.96667 14.6791C5.0171 14.7311 5.08597 14.761 5.15833 14.7625C5.22504 14.7633 5.28939 14.7378 5.3375 14.6916C5.38817 14.6438 5.41809 14.578 5.42083 14.5083C5.42211 14.4739 5.41651 14.4396 5.40434 14.4074C5.39218 14.3752 5.3737 14.3458 5.35 14.3208C4.97917 13.925 4.7125 13.6458 4.51667 13.4416L4.1 12.9958L4.55417 12.5791C5.23117 11.9456 5.96795 11.379 6.75417 10.8875C7.76711 10.2236 8.89908 9.76236 10.0875 9.52914C10.1569 9.51979 10.2198 9.48352 10.2627 9.42817C10.3056 9.37282 10.325 9.30283 10.3167 9.23331C10.3126 9.19927 10.3017 9.16638 10.2848 9.13658C10.2678 9.10677 10.2451 9.08063 10.218 9.05969C10.1908 9.03875 10.1598 9.02342 10.1267 9.0146C10.0935 9.00577 10.059 9.00364 10.025 9.00831C8.77311 9.2383 7.58011 9.7172 6.51667 10.4166L5.575 10.9916V9.88747C5.575 9.68331 5.575 9.47081 5.575 9.28331C5.5755 9.24865 5.56912 9.21424 5.55625 9.18206C5.54338 9.14987 5.52426 9.12056 5.5 9.09581C5.45187 9.0455 5.38622 9.01565 5.31667 9.01247V9.01247C5.24775 9.01134 5.18115 9.03737 5.13126 9.08492C5.08137 9.13248 5.05218 9.19775 5.05 9.26664C5.01667 10.3083 5.0125 10.825 5.05 11.1041V11.4125L4.8125 11.6083C3.93917 12.3413 3.1408 13.1592 2.42917 14.05L1.90417 14.7333L1.46667 13.9541C0.986778 13.0619 0.72182 12.0699 0.692886 11.0572C0.663951 10.0445 0.871839 9.03901 1.3 8.12081C1.6874 7.20543 2.28753 6.39564 3.05059 5.75867C3.81365 5.1217 4.71763 4.67591 5.6875 4.45831C6.65006 4.28052 7.62552 4.18158 8.60417 4.16247L9.3375 4.12914C11.1375 4.02497 13.0042 3.74581 14.45 2.38747C15.125 1.75414 15.7 1.74164 16.0375 1.84581C16.375 1.94997 16.8708 2.26247 17.0792 3.14997C17.4088 4.33129 17.647 5.53624 17.7917 6.75414C17.949 8.20787 17.7964 9.67844 17.344 11.0689C16.8915 12.4593 16.1494 13.7381 15.1667 14.8208C14.1745 15.8909 12.9686 16.7406 11.6271 17.3148C10.2855 17.889 8.83829 18.175 7.37917 18.1541H7.2875C7.22381 18.1533 7.16044 18.1632 7.1 18.1833C7.07044 18.1893 7.04221 18.2006 7.01667 18.2166V18.2166C6.97858 18.2436 6.94741 18.2791 6.92568 18.3204C6.90396 18.3617 6.8923 18.4075 6.89167 18.4541C6.88766 18.4935 6.89169 18.5332 6.9035 18.5709C6.91531 18.6086 6.93466 18.6435 6.96038 18.6735C6.9861 18.7035 7.01765 18.728 7.05311 18.7454C7.08857 18.7629 7.1272 18.7729 7.16667 18.775V18.775Z"
                fill="black"
              />
            </svg>
          </div>
          <div class="col-8 d-flex flex-column justify-content-center pt-2">
            <div class="card-counter">{{ $t("activity") }}</div>
            <div class="card-title">{{ $t("material") }}</div>
          </div>
        </div>
        <div class="card-widget">
          <div class="img-border">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.0458 11.1542L10.5708 8.12915L9.09167 11.1542C8.99583 11.3625 8.9375 11.5917 8.9375 11.8333C8.9375 12.7333 9.66667 13.4625 10.5667 13.4625C11.4667 13.4625 12.1958 12.7333 12.1958 11.8333C12.1958 11.5917 12.1375 11.3625 12.0417 11.1542H12.0458Z"
                fill="#BEDB74"
              />
              <path
                d="M14.925 9.28756C17.3297 9.28756 19.2792 7.33813 19.2792 4.93339C19.2792 2.52865 17.3297 0.579224 14.925 0.579224C12.5203 0.579224 10.5708 2.52865 10.5708 4.93339C10.5708 7.33813 12.5203 9.28756 14.925 9.28756Z"
                fill="#A47AA9"
              />
              <path
                d="M15.2042 14.9C15.6125 14.3 16.1375 13.2875 16.3125 11.8541V11.8208C16.3333 11.75 16.325 11.6791 16.3 11.6208C16.2292 11.4666 16.05 11.3958 15.8917 11.4625C15.7292 11.5333 15.7125 11.675 15.7 11.7791C15.5417 13.0708 14.9083 15.3875 12.4125 16.3625V16.3541C12.1667 16.5208 11.0917 16.825 10.2833 16.825H10.2125L10.2042 16.5791C10.2042 16.4791 10.2 16.375 10.1958 16.2833C10.1875 16.0833 10.0792 15.9625 9.90834 15.9625C9.73334 15.9625 9.62917 16.0791 9.625 16.2833C9.625 16.3916 9.625 16.4958 9.625 16.6041V16.825H9.55C6.30417 16.6916 4.04584 13.8041 4.04167 11.2958V11.225H4.42084C4.83334 11.225 4.89167 11.0708 4.89167 10.9416C4.89167 10.8625 4.87084 10.8041 4.82917 10.7625C4.75834 10.6916 4.625 10.65 4.42917 10.65C4.35 10.65 4.27084 10.6458 4.19167 10.6416L4 10.6333L4.00834 10.5583C4.0125 10.5041 4.01667 10.4541 4.02084 10.4041C4.02917 10.3 4.0375 10.2083 4.05 10.1166C4.45 7.36663 6.64584 5.27913 9.3875 5.04997C12.6125 4.77913 14.9542 7.00413 15.6 9.3458C15.6333 9.47497 15.6625 9.6083 15.6917 9.73747C15.7167 9.8458 15.7375 9.95413 15.7667 10.0625C15.775 10.0916 15.7833 10.1208 15.7958 10.1458C15.8417 10.25 15.9375 10.3166 16.05 10.3166C16.2 10.3166 16.3208 10.1958 16.3208 10.0458C16.3208 10.0375 16.3208 10.0291 16.3208 10.0208C16.325 9.96247 16.3125 9.90413 16.3042 9.84997L16.2958 9.80413C15.7708 6.71247 12.9542 4.4458 9.89167 4.4458C9.55834 4.4458 9.22084 4.4708 8.8875 4.52913C6.94167 4.84997 5.26667 6.01247 4.2875 7.72497C3.3125 9.42497 3.15834 11.4416 3.85417 13.2583C4.79167 15.7 7.08334 17.3333 9.69167 17.4208C9.7125 17.4208 9.725 17.4208 9.7375 17.4208H9.875C10.0042 17.4208 10.1333 17.4208 10.2667 17.4125C11.3917 17.3625 12.3875 17.1125 13.225 16.6708C14.025 16.25 14.6917 15.6541 15.2083 14.9H15.2042Z"
                fill="black"
              />
              <path
                d="M18.7042 10.9333C18.7042 10.7708 18.7 10.6083 18.6917 10.4416C18.6958 10.3916 18.6958 10.3541 18.6917 10.3166C18.6 9.11247 18.2833 7.97913 17.7458 6.94163C17.3917 6.24163 16.9417 5.5958 16.4167 5.01247L16.375 4.96663L16.8792 4.3708L16.9333 4.42497C16.9667 4.4583 16.9958 4.48747 17.025 4.51247C17.0833 4.5708 17.1333 4.6208 17.1917 4.66663C17.325 4.77913 17.4792 4.77913 17.5875 4.66663C17.7 4.54997 17.7042 4.38747 17.6 4.27497C17.275 3.93747 16.9292 3.58747 16.575 3.2458C16.4542 3.12913 16.3 3.12913 16.1792 3.24163C16.0625 3.35413 16.0625 3.51663 16.1792 3.65413C16.2292 3.71663 16.2875 3.7708 16.3417 3.82497L16.4542 3.93747L15.925 4.5083L15.8708 4.4583C14.6667 3.34163 13.1833 2.58747 11.5833 2.2708L11.525 2.2583V2.19997C11.525 2.09997 11.525 1.99997 11.525 1.89997C11.525 1.6833 11.525 1.4708 11.525 1.26247C11.5083 0.691634 11.0667 0.249967 10.5 0.233301C10.15 0.224967 9.775 0.224967 9.2875 0.233301C9.00417 0.237467 8.75833 0.349967 8.55417 0.562467C8.46667 0.654134 8.34583 0.837467 8.52083 1.0083C8.63333 1.1208 8.78333 1.1083 8.95833 0.974967C9.1 0.866634 9.22083 0.812467 9.33333 0.808301C9.65 0.791634 9.975 0.795801 10.2875 0.799967H10.4583C10.7208 0.804134 10.9083 0.949967 10.9333 1.16663C10.9583 1.3833 10.9542 1.60413 10.9458 1.81663C10.9458 1.90413 10.9417 1.9958 10.9417 2.0833V2.16663L10.8625 2.1583C8.3 1.87497 5.78333 2.71247 3.90833 4.44163L3.85833 4.48747L3.2875 3.9083L3.35 3.8583C3.37917 3.83747 3.40833 3.81247 3.4375 3.79163C3.49583 3.7458 3.55417 3.70413 3.6 3.65413C3.725 3.5208 3.72917 3.3583 3.61667 3.24163C3.49583 3.1208 3.3375 3.1208 3.20833 3.24163C2.87083 3.56663 2.52917 3.9083 2.2 4.25413C2.0875 4.3708 2.08333 4.5333 2.19167 4.64997C2.30833 4.7708 2.46667 4.7708 2.60417 4.64997C2.66667 4.59997 2.72083 4.5458 2.77917 4.49163L2.90417 4.37497L3.44583 4.89997L3.39583 4.95413C2.45833 5.9708 1.76667 7.2083 1.39167 8.52913C1.2125 9.14163 1.10833 9.77913 1.075 10.4208C1.06667 10.5916 1.05833 10.7625 1.05833 10.9291C1.05833 12.5708 1.51667 14.1791 2.38333 15.5708C4.30417 18.6958 7.90417 20.2791 11.5583 19.6125C11.6375 19.6 11.7042 19.5791 11.7583 19.5541C15.7917 18.6666 18.7042 15.0458 18.7042 10.9291V10.9333ZM9.87917 19.1875C6.14583 19.1875 2.86667 16.6708 1.90417 13.0625L1.87917 12.9708C1.56667 11.7208 1.55417 10.4666 1.8375 9.22913C2.0375 8.3458 2.3375 7.5333 2.73333 6.8083C3.4875 5.50413 4.58333 4.42913 5.90417 3.70413C6.5875 3.35413 7.34583 3.0833 8.16667 2.9083C8.9125 2.7458 9.65 2.67497 10.3583 2.6958C11.8458 2.7833 13.2833 3.2708 14.5167 4.1083C15.1875 4.58747 15.8208 5.19163 16.4 5.89997C16.5125 6.03747 16.6208 6.1833 16.7292 6.3333C17.65 7.6958 18.1333 9.28747 18.1333 10.9333C18.1333 15.4833 14.4292 19.1875 9.87917 19.1875Z"
                fill="black"
              />
              <path
                d="M9.85833 12.5083C9.54999 12.5083 9.24583 12.4333 8.98333 12.2875C8.67083 12.1125 8.42499 11.8625 8.25416 11.5333C8.19166 11.4125 8.23749 11.2583 8.35833 11.1958C8.47916 11.1333 8.63333 11.1792 8.69583 11.3C8.82083 11.5375 8.99999 11.725 9.22499 11.85C9.59166 12.0542 10.0583 12.0625 10.475 11.875C11.3458 11.4833 11.3542 10.5083 11.1625 10.0708C10.9167 9.50833 10.25 8.12916 9.91666 7.44166L8.70416 9.99166C8.64583 10.1167 8.49583 10.1708 8.37083 10.1083C8.24583 10.05 8.19166 9.89999 8.25416 9.77499L9.72916 6.67916L9.91666 6.65833C10.025 6.65833 10.1292 6.72083 10.175 6.82083C10.2208 6.91249 11.2875 9.09999 11.625 9.86666C11.925 10.5542 11.8333 11.8125 10.6833 12.3292C10.4208 12.4458 10.1417 12.5042 9.86666 12.5042L9.85833 12.5083Z"
                fill="black"
              />
            </svg>
          </div>
          <div class="col-8 d-flex flex-column justify-content-center pt-2">
            <div class="card-counter">{{ $t("status") }}</div>
            <div class="card-title">{{ $t("finished") }}</div>
          </div>
        </div>
        <div class="card-widget">
          <div class="img-border">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1079_32996)">
                <path
                  d="M14.1542 15.3833V18.6417C14.1542 18.9458 14.5208 19.0958 14.7333 18.8833L18.1875 15.4292C18.4917 15.125 18.2833 14.6042 17.85 14.5958L15.0167 14.5375C14.5417 14.5292 14.15 14.9125 14.15 15.3875L14.1542 15.3833Z"
                  fill="#A47AA9"
                />
                <path
                  d="M10.8542 1.60828H2.33749C1.47915 1.60828 0.783325 2.3041 0.783325 3.16244C0.783325 4.02079 1.47915 4.71661 2.33749 4.71661H10.8542C11.7125 4.71661 12.4083 4.02079 12.4083 3.16244C12.4083 2.3041 11.7125 1.60828 10.8542 1.60828Z"
                  fill="#BEDB74"
                />
                <path
                  d="M16.7417 0.916585L16.7333 0.895752L16.7417 0.916585Z"
                  fill="black"
                />
                <path
                  d="M16.5417 0.591634L16.525 0.570801C16.525 0.570801 16.5375 0.583301 16.5417 0.591634Z"
                  fill="black"
                />
                <path
                  d="M14.1417 0.6875L14.1333 0.7L14.1417 0.6875Z"
                  fill="black"
                />
                <path
                  d="M14.2333 12.0458L14.2208 12.0375C13.3833 11.4666 12.5458 10.8916 11.7083 10.3208L10.1708 9.27079C9.62082 8.89579 9.07499 8.52079 8.52499 8.14579C8.39999 8.05829 8.20832 7.94996 7.96665 7.99163C7.59999 8.05413 7.37082 8.32912 7.36665 8.70412C7.36665 8.85829 7.36665 9.01246 7.36665 9.16662C7.36665 9.39996 7.36665 9.63746 7.36249 9.87496C7.35832 10.0708 7.42499 10.2 7.58749 10.3125C8.14165 10.6875 8.70415 11.0708 9.24582 11.4416L10.125 12.0416C10.325 12.1791 10.525 12.3166 10.725 12.4541C10.7958 12.5041 10.8375 12.5708 10.8375 12.6375C10.8375 12.7083 10.8 12.775 10.725 12.8291C10.6958 12.85 10.6667 12.8708 10.6375 12.8916L10.325 13.1041C9.78749 13.4708 9.25415 13.8333 8.71665 14.2041L8.65832 14.2458C8.59165 14.2916 8.55415 14.3666 8.55415 14.4458C8.55415 14.5791 8.66249 14.6875 8.79582 14.6875C8.84165 14.6875 8.88332 14.675 8.91665 14.6541C8.92499 14.65 8.93749 14.6416 8.94999 14.6333L9.66249 14.15C10.1 13.8541 10.55 13.5458 11 13.2333C11.2042 13.0916 11.325 12.875 11.325 12.6458C11.325 12.4125 11.2042 12.1916 10.9958 12.0458C10.8042 11.9125 10.6125 11.7833 10.4208 11.65L9.71249 11.1666C9.10415 10.75 8.49582 10.3333 7.88749 9.91662C7.87082 9.90412 7.85832 9.89162 7.85415 9.88329C7.84999 9.52496 7.84582 9.09996 7.85415 8.67912C7.85415 8.61246 7.88332 8.55413 7.93332 8.51663C7.97915 8.47913 8.03332 8.46663 8.08749 8.47496C8.12915 8.48329 8.17915 8.50412 8.23332 8.54162C9.68749 9.53329 11.1458 10.5291 12.6 11.5208L13.1 11.8625C13.3792 12.0541 13.6625 12.2458 13.9417 12.4375C14.025 12.4958 14.0708 12.5625 14.0708 12.6333C14.0708 12.7041 14.025 12.7791 13.9417 12.8375L8.86665 16.3041L8.80832 16.3458C8.61665 16.4791 8.42082 16.6083 8.22915 16.7416C8.12915 16.8083 8.05415 16.8208 7.97499 16.7791C7.88749 16.7375 7.85415 16.6625 7.85415 16.5458V11.7666C7.85415 11.6333 7.74165 11.5208 7.60832 11.5208C7.47499 11.5208 7.36249 11.6291 7.36249 11.7666V16.3083C7.36249 16.4166 7.36249 16.5291 7.36665 16.6416C7.38749 16.95 7.60415 17.2041 7.91249 17.275C7.96249 17.2875 8.01249 17.2916 8.06249 17.2916C8.26249 17.2916 8.42499 17.2 8.52499 17.1291C9.14165 16.7083 9.75832 16.2875 10.375 15.8666L12.675 14.2958C13.1875 13.9458 13.6958 13.5958 14.2083 13.25C14.3667 13.1416 14.4667 13.0166 14.5208 12.8666C14.625 12.5583 14.5125 12.2458 14.2375 12.05L14.2333 12.0458Z"
                  fill="black"
                />
                <path
                  d="M19.7833 2.85831C19.7833 2.45414 19.4583 2.12497 19.0625 2.12497H16.9125C16.8875 2.11664 16.8625 2.10831 16.8375 2.08331C16.8042 2.04997 16.7875 2.00831 16.7875 1.95831V1.83331C16.7875 1.71664 16.7917 1.60414 16.7875 1.49997C16.75 0.941639 16.4917 0.533306 16.0208 0.287473C15.5458 0.0416396 15.075 0.0666396 14.6167 0.362473C14.2458 0.60414 14.0375 0.96664 13.9958 1.44997V2.04164C13.9958 2.07497 13.9708 2.10414 13.9333 2.11247C13.3625 2.11247 12.9167 2.11664 12.6 2.11664C11.1417 2.11664 10.3917 2.11664 10.3708 2.11664C10.2417 2.11664 10.1333 2.22081 10.1333 2.35414V2.37081C10.1333 2.49997 10.2375 2.60414 10.3708 2.60414C10.3917 2.60414 11.1458 2.60414 12.6125 2.60414C13.0792 2.60414 13.4958 2.60414 13.7375 2.60414H13.9083C13.95 2.60414 13.9792 2.64164 13.9792 2.67914V3.27081C13.9792 3.27081 13.9792 3.28331 13.9792 3.29581C13.9875 3.62081 14.125 3.91664 14.3875 4.17914C14.6458 4.44997 14.9792 4.59997 15.325 4.59997H15.3583C15.4542 4.59997 15.5375 4.56247 15.5833 4.49997C15.6208 4.44997 15.6292 4.38331 15.6125 4.31247C15.5833 4.21247 15.5292 4.14997 15.3458 4.12914C15.1333 4.10414 14.9417 4.02914 14.7917 3.91247C14.7583 3.88747 14.7292 3.86247 14.7 3.83331C14.675 3.80414 14.6542 3.78331 14.6333 3.75831C14.625 3.74997 14.6167 3.73747 14.6083 3.72497C14.5208 3.59581 14.475 3.45414 14.4708 3.29581C14.4542 2.71247 14.4542 2.10831 14.4708 1.45414C14.4833 1.03747 14.8083 0.69164 15.2458 0.62914C15.5292 0.587473 15.7792 0.658306 15.975 0.820806C16.1875 0.999973 16.3083 1.28331 16.3167 1.61664C16.3167 1.66664 16.3167 1.77081 16.3167 1.93331C16.3167 2.02497 16.2458 2.10414 16.15 2.12081H15.8125C15.7458 2.12081 15.6875 2.14997 15.6375 2.20414V2.21247L15.6208 2.22497C15.5875 2.26664 15.5708 2.31247 15.5708 2.36247C15.5708 2.39581 15.5792 2.42914 15.5958 2.46664C15.6417 2.57497 15.7875 2.61247 15.8958 2.61247C16.1042 2.61247 19.0375 2.60414 19.0708 2.60414C19.2042 2.60414 19.3125 2.71664 19.3125 2.85831V4.54997C19.3125 4.68331 19.4208 4.79164 19.5542 4.79164C19.6875 4.79164 19.7958 4.68331 19.7958 4.54997V2.85831H19.7833Z"
                  fill="black"
                />
                <path
                  d="M19.8667 6.39583V6.20833C19.8667 6.16667 19.8667 6.13333 19.8667 6.09583C19.85 5.85417 19.6917 5.79583 19.5958 5.77917C19.5458 5.77917 19.4917 5.775 19.4375 5.775H2.74582C2.61665 5.775 2.50832 5.88333 2.50832 6.0125C2.50832 6.14167 2.61665 6.25 2.74582 6.25H3.07082C8.12915 6.25 18.3417 6.25 19.2792 6.25C19.3417 6.25 19.3917 6.3 19.3917 6.3625V15.4167L19.35 15.425C19.3208 15.425 16.5417 15.425 16.2833 15.425C15.7333 15.425 15.3625 15.8042 15.3542 16.3583C15.3542 16.6625 15.3542 16.9708 15.3542 17.2875C15.3542 17.575 15.4833 17.6125 15.5833 17.6125C15.6542 17.6125 15.7042 17.5958 15.7417 17.5625C15.7958 17.5125 15.825 17.4125 15.825 17.2792C15.825 17.125 15.825 16.8292 15.825 16.6167V16.3208C15.825 16.2042 15.875 16.0917 15.9667 16.0125C15.9792 16 15.9875 15.9958 15.9958 15.9875C16.0042 15.9833 16.0125 15.9792 16.0208 15.9708L16.0417 15.9583C16.0833 15.9333 16.1333 15.9167 16.1875 15.9125C16.3208 15.8875 18.8 15.9 18.825 15.9H19.0542L18.8667 16.0875C17.3417 17.6125 16.2833 18.6708 15.725 19.2375C15.5708 19.3958 15.4 19.4625 15.1708 19.4625C13.5292 19.4625 10.7292 19.4625 7.97082 19.4625H7.64165C3.23749 19.4625 0.991652 19.4625 0.949986 19.4583C0.712486 19.4417 0.570819 19.3042 0.545819 19.0667C0.545819 18.9792 0.545819 7.7 0.545819 3.99167V3.3625C0.545819 2.95833 0.874986 2.62083 1.28332 2.6125H1.34582C1.96249 2.6125 3.07082 2.6125 3.08749 2.6125H3.13332L3.14165 2.65417C3.14165 2.65417 3.14165 3.075 3.14165 3.16667C3.14999 3.8 3.44999 4.24583 4.02499 4.50417C4.19999 4.57917 4.41665 4.59167 4.59165 4.59167C4.61249 4.59167 4.63749 4.59167 4.65832 4.58333C4.76665 4.5625 4.84165 4.475 4.84165 4.37083C4.84165 4.25417 4.74582 4.15417 4.62915 4.15417H4.59165C4.54999 4.14167 4.51665 4.1375 4.48749 4.13333C4.42915 4.125 4.37499 4.11667 4.32499 4.10417C3.92499 4.00417 3.64999 3.6875 3.63749 3.3125C3.61665 2.67917 3.61665 2.09167 3.63749 1.52083C3.65415 1.06667 3.99582 0.687499 4.42915 0.629165C4.89999 0.570832 5.32082 0.841665 5.42499 1.275C5.45832 1.41667 5.46249 1.75833 5.46249 1.9C5.46249 2.0125 5.37499 2.1 5.26249 2.10417H4.99165C4.84999 2.10417 4.73749 2.22083 4.73749 2.3625C4.73749 2.47083 4.80832 2.57083 4.91665 2.60417C5.00415 2.61667 6.69582 2.62083 8.32915 2.62083C8.44999 2.62083 8.54582 2.71667 8.54582 2.8375V3C8.55415 3.05833 8.55415 3.14583 8.55832 3.2375C8.58749 3.97917 9.15832 4.57917 9.85832 4.60833H9.89582C10.1792 4.60833 10.1875 4.46667 10.1917 4.39583C10.2 4.24583 10.1208 4.17083 9.90832 4.14166C9.35415 4.06666 9.04582 3.72083 9.03749 3.175C9.02915 2.6 9.03332 2.05 9.03749 1.59167C9.04165 1.13333 9.26249 0.808332 9.65832 0.674999C10.0625 0.537499 10.4417 0.662499 10.7292 1.025C10.8958 1.23333 11.0167 1.17917 11.0958 1.12083C11.1875 1.05417 11.2542 0.958332 11.1083 0.741665C10.9 0.424999 10.5583 0.212499 10.1708 0.158332C9.77082 0.104165 9.36249 0.216665 9.05832 0.470832C8.73332 0.741665 8.56665 1.1 8.55832 1.56667V1.90833C8.55832 2.01667 8.47082 2.10833 8.35832 2.10833H6.15832C6.04165 2.10833 5.94999 2.01667 5.94999 1.90417C5.94999 1.875 5.94999 1.5375 5.94999 1.50417C5.89999 0.770832 5.34582 0.187499 4.65832 0.149999C4.62915 0.149999 4.59999 0.149999 4.57082 0.149999C3.84165 0.149999 3.27499 0.633332 3.15832 1.35417C3.14582 1.41667 3.14165 1.47917 3.13749 1.54583V2.15L1.29582 2.13333C0.612486 2.12083 0.0583191 2.675 0.0583191 3.35833V18.9083C0.0583191 19.5833 0.420819 19.9417 1.10415 19.9417H6.12915C7.97499 19.9417 9.84582 19.9417 11.7167 19.9417C12.6 19.9417 13.4833 19.9417 14.3625 19.9417C14.7667 19.9417 15.1625 19.9417 15.5542 19.9167C15.65 19.9125 15.7375 19.8708 15.8042 19.8042C16.2583 19.3542 17.2708 18.3417 18.1667 17.4458L19.7042 15.9125C19.8208 15.7958 19.8708 15.6708 19.8708 15.4833C19.8708 13.5542 19.8708 8.95833 19.8708 6.39167L19.8667 6.39583Z"
                  fill="black"
                />
              </g>
              <defs>
                <clipPath id="clip0_1079_32996">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="col-8 d-flex flex-column justify-content-center pt-2">
            <div class="card-counter">{{ $t("creationDate") }}</div>
            <div class="card-title">
              {{ formatDateToBR(details.usuario_recebimento_material_data) }}
            </div>
          </div>
        </div>
        <div class="card-widget">
          <div class="img-border">
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1079_33006)">
                <path
                  d="M15.1092 15.3833V18.6417C15.1092 18.9458 15.4758 19.0958 15.6883 18.8833L19.1425 15.4292C19.4467 15.125 19.2383 14.6042 18.805 14.5958L15.9717 14.5375C15.4967 14.5292 15.105 14.9125 15.105 15.3875L15.1092 15.3833Z"
                  fill="#A47AA9"
                />
                <path
                  d="M11.8092 1.60828H3.29251C2.43417 1.60828 1.73834 2.3041 1.73834 3.16244C1.73834 4.02079 2.43417 4.71661 3.29251 4.71661H11.8092C12.6675 4.71661 13.3633 4.02079 13.3633 3.16244C13.3633 2.3041 12.6675 1.60828 11.8092 1.60828Z"
                  fill="#BEDB74"
                />
                <path
                  d="M15.1092 15.3833V18.6417C15.1092 18.9458 15.4758 19.0958 15.6883 18.8833L19.1425 15.4292C19.4467 15.125 19.2383 14.6042 18.805 14.5958L15.9717 14.5375C15.4967 14.5292 15.105 14.9125 15.105 15.3875L15.1092 15.3833Z"
                  fill="#A47AA9"
                />
                <path
                  d="M20.7383 2.85831C20.7383 2.45414 20.4133 2.12497 20.0175 2.12497H17.8675C17.8425 2.11664 17.8175 2.10831 17.7925 2.08331C17.7592 2.04997 17.7425 2.00831 17.7425 1.95831V1.83331C17.7425 1.71664 17.7467 1.60414 17.7425 1.49997C17.705 0.941639 17.4467 0.533306 16.9758 0.287473C16.5008 0.0416396 16.03 0.0666396 15.5717 0.362473C15.2008 0.60414 14.9925 0.96664 14.9508 1.44997V2.04164C14.9508 2.07497 14.9258 2.10414 14.8883 2.11247C14.3175 2.11247 13.8717 2.11664 13.555 2.11664C12.0967 2.11664 11.3467 2.11664 11.3258 2.11664C11.1967 2.11664 11.0883 2.22081 11.0883 2.35414V2.37081C11.0883 2.49997 11.1925 2.60414 11.3258 2.60414C11.3467 2.60414 12.1008 2.60414 13.5675 2.60414C14.0342 2.60414 14.4508 2.60414 14.6925 2.60414H14.8633C14.905 2.60414 14.9342 2.64164 14.9342 2.67914V3.27081C14.9342 3.27081 14.9342 3.28331 14.9342 3.29581C14.9425 3.62081 15.08 3.91664 15.3425 4.17914C15.6008 4.44997 15.9342 4.59997 16.28 4.59997H16.3133C16.4092 4.59997 16.4925 4.56247 16.5383 4.49997C16.5758 4.44997 16.5842 4.38331 16.5675 4.31247C16.5383 4.21247 16.4842 4.14997 16.3008 4.12914C16.0883 4.10414 15.8967 4.02914 15.7467 3.91247C15.7133 3.88747 15.6842 3.86247 15.655 3.83331C15.63 3.80414 15.6092 3.78331 15.5883 3.75831C15.58 3.74997 15.5717 3.73747 15.5633 3.72497C15.4758 3.59581 15.43 3.45414 15.4258 3.29581C15.4092 2.71247 15.4092 2.10831 15.4258 1.45414C15.4383 1.03747 15.7633 0.69164 16.2008 0.62914C16.4842 0.587473 16.7342 0.658306 16.93 0.820806C17.1425 0.999973 17.2633 1.28331 17.2717 1.61664C17.2717 1.66664 17.2717 1.77081 17.2717 1.93331C17.2717 2.02497 17.2008 2.10414 17.105 2.12081H16.7675C16.7008 2.12081 16.6425 2.14997 16.5925 2.20414V2.21247L16.5758 2.22497C16.5425 2.26664 16.5258 2.31247 16.5258 2.36247C16.5258 2.39581 16.5342 2.42914 16.5508 2.46664C16.5967 2.57497 16.7425 2.61247 16.8508 2.61247C17.0592 2.61247 19.9925 2.60414 20.0258 2.60414C20.1592 2.60414 20.2675 2.71664 20.2675 2.85831V4.54997C20.2675 4.68331 20.3758 4.79164 20.5092 4.79164C20.6425 4.79164 20.7508 4.68331 20.7508 4.54997V2.85831H20.7383Z"
                  fill="black"
                />
                <path
                  d="M10.6508 13.2501C10.7925 13.2501 10.9342 13.2001 11.0383 13.0959L12.6467 11.4876C12.7383 11.3959 12.7383 11.2417 12.6467 11.1501C12.6008 11.1042 12.5425 11.0792 12.4758 11.0792C12.4092 11.0792 12.3508 11.1042 12.3092 11.1501L10.755 12.7042C10.6967 12.7626 10.605 12.7626 10.5467 12.7042L9.83417 11.9876C9.7925 11.9459 9.73 11.9209 9.66333 11.9209C9.59667 11.9209 9.53833 11.9459 9.49667 11.9876C9.405 12.0792 9.405 12.2334 9.49667 12.3251L10.2633 13.0959C10.3675 13.2001 10.5092 13.2501 10.6508 13.2501Z"
                  fill="black"
                />
                <path
                  d="M8.95083 15.1833C8.90917 15.1417 8.85083 15.1208 8.79667 15.1208C8.74667 15.1208 8.6925 15.1375 8.655 15.1708C8.61333 15.2083 8.58833 15.2625 8.58833 15.3167C8.58833 15.3708 8.605 15.425 8.6425 15.4667C8.6925 15.525 9.18 16.025 9.88 16.1708C9.98417 16.1917 10.105 16.1167 10.1258 16.0083C10.1508 15.8958 10.0758 15.7833 9.96333 15.7625C9.38833 15.6459 8.96333 15.2042 8.94667 15.1875L8.95083 15.1833Z"
                  fill="black"
                />
                <path
                  d="M11.1467 16.3542H11.1675C11.3342 16.35 11.4842 16.3375 11.6342 16.3208C12.63 16.1958 13.555 15.7167 14.2467 14.9708C14.9383 14.2292 15.3467 13.2667 15.3967 12.2625C15.4592 11.0792 15.0383 9.94584 14.2092 9.07501C13.4258 8.24584 12.3175 7.75001 11.1758 7.71667C11.0675 7.71667 10.9508 7.72084 10.8217 7.72917C10.6842 7.74167 10.5425 7.75417 10.405 7.77501C8.76333 8.06667 7.63 9.00417 7.0425 10.5542C6.4675 12.0708 6.7175 13.5083 7.78417 14.8167C7.805 14.8417 7.83 14.875 7.85917 14.8958C7.96333 14.9708 8.055 14.9708 8.14667 14.8958C8.23833 14.8167 8.255 14.7208 8.1925 14.6208C8.16333 14.575 8.13 14.5292 8.09667 14.4917L8.05917 14.4458C7.53833 13.8042 7.255 13.0625 7.20917 12.2417C7.14667 11.0958 7.59667 9.99167 8.4425 9.20417C9.1675 8.53334 10.1008 8.16251 11.08 8.16251C11.2425 8.16251 11.4092 8.17501 11.5717 8.19167C13.2675 8.40834 14.605 9.70834 14.9092 11.425C15.1925 13.0417 14.355 14.7042 12.8675 15.475C12.33 15.7542 11.755 15.9 11.155 15.9083C10.9717 15.9083 10.8675 15.9917 10.8675 16.1333C10.8675 16.2 10.8842 16.25 10.9217 16.2833C10.9675 16.325 11.0467 16.35 11.1467 16.35V16.3542Z"
                  fill="black"
                />
                <path
                  d="M20.8217 6.39583V6.20833C20.8217 6.16667 20.8217 6.13333 20.8217 6.09583C20.805 5.85417 20.6467 5.79583 20.5508 5.77917C20.5008 5.77917 20.4467 5.775 20.3925 5.775H3.70084C3.57167 5.775 3.46334 5.88333 3.46334 6.0125C3.46334 6.14167 3.57167 6.25 3.70084 6.25H4.02584C9.08417 6.25 19.2967 6.25 20.2342 6.25C20.2967 6.25 20.3467 6.3 20.3467 6.3625V15.4167L20.305 15.425C20.2758 15.425 17.4967 15.425 17.2383 15.425C16.6883 15.425 16.3175 15.8042 16.3092 16.3583C16.3092 16.6625 16.3092 16.9708 16.3092 17.2875C16.3092 17.575 16.4383 17.6125 16.5383 17.6125C16.6092 17.6125 16.6592 17.5958 16.6967 17.5625C16.7508 17.5125 16.78 17.4125 16.78 17.2792C16.78 17.125 16.78 16.8292 16.78 16.6167V16.3208C16.78 16.2042 16.83 16.0917 16.9217 16.0125C16.9342 16 16.9425 15.9958 16.9508 15.9875C16.9592 15.9833 16.9675 15.9792 16.9758 15.9708L16.9967 15.9583C17.0383 15.9333 17.0883 15.9167 17.1425 15.9125C17.2758 15.8875 19.755 15.9 19.78 15.9H20.0092L19.8217 16.0875C18.2967 17.6125 17.2383 18.6708 16.68 19.2375C16.5258 19.3958 16.355 19.4625 16.1258 19.4625C14.4842 19.4625 11.6842 19.4625 8.92584 19.4625H8.59667C4.1925 19.4625 1.94667 19.4625 1.905 19.4583C1.6675 19.4417 1.52584 19.3042 1.50084 19.0667C1.50084 18.9792 1.50084 7.7 1.50084 3.99167V3.3625C1.50084 2.95833 1.83 2.62083 2.23834 2.6125H2.30084C2.9175 2.6125 4.02584 2.6125 4.0425 2.6125H4.08834L4.09667 2.65417C4.09667 2.65417 4.09667 3.075 4.09667 3.16667C4.105 3.8 4.405 4.24583 4.98 4.50417C5.155 4.57917 5.37167 4.59167 5.54667 4.59167C5.5675 4.59167 5.5925 4.59167 5.61334 4.58333C5.72167 4.5625 5.79667 4.475 5.79667 4.37083C5.79667 4.25417 5.70084 4.15417 5.58417 4.15417H5.54667C5.505 4.14167 5.47167 4.1375 5.4425 4.13333C5.38417 4.125 5.33 4.11667 5.28 4.10417C4.88 4.00417 4.605 3.6875 4.5925 3.3125C4.57167 2.67917 4.57167 2.09167 4.5925 1.52083C4.60917 1.06667 4.95084 0.687499 5.38417 0.629165C5.855 0.570832 6.27584 0.841665 6.38 1.275C6.41334 1.41667 6.4175 1.75833 6.4175 1.9C6.4175 2.0125 6.33 2.1 6.2175 2.10417H5.94667C5.805 2.10417 5.6925 2.22083 5.6925 2.3625C5.6925 2.47083 5.76334 2.57083 5.87167 2.60417C5.95917 2.61667 7.65084 2.62083 9.28417 2.62083C9.405 2.62083 9.50084 2.71667 9.50084 2.8375V3C9.50917 3.05833 9.50917 3.14583 9.51334 3.2375C9.5425 3.97917 10.1133 4.57917 10.8133 4.60833H10.8508C11.1342 4.60833 11.1425 4.46667 11.1467 4.39583C11.155 4.24583 11.0758 4.17083 10.8633 4.14167C10.3092 4.06667 10.0008 3.72083 9.9925 3.175C9.98417 2.6 9.98834 2.05 9.9925 1.59167C9.99667 1.13333 10.2175 0.808332 10.6133 0.674999C11.0175 0.537499 11.3967 0.662499 11.6842 1.025C11.8508 1.23333 11.9717 1.17917 12.0508 1.12083C12.1425 1.05417 12.2092 0.958332 12.0633 0.741665C11.855 0.424999 11.5133 0.212499 11.1258 0.158332C10.7258 0.104165 10.3175 0.216665 10.0133 0.470832C9.68834 0.741665 9.52167 1.1 9.51334 1.56667V1.90833C9.51334 2.01667 9.42584 2.10833 9.31334 2.10833H7.11334C6.99667 2.10833 6.905 2.01667 6.905 1.90417C6.905 1.875 6.905 1.5375 6.905 1.50417C6.855 0.770832 6.30084 0.187499 5.61334 0.149999C5.58417 0.149999 5.555 0.149999 5.52584 0.149999C4.79667 0.149999 4.23 0.633332 4.11334 1.35417C4.10084 1.41667 4.09667 1.47917 4.0925 1.54583V2.15L2.25084 2.13333C1.5675 2.12083 1.01334 2.675 1.01334 3.35833V18.9083C1.01334 19.5833 1.37584 19.9417 2.05917 19.9417H7.08417C8.93 19.9417 10.8008 19.9417 12.6717 19.9417C13.555 19.9417 14.4383 19.9417 15.3175 19.9417C15.7217 19.9417 16.1175 19.9417 16.5092 19.9167C16.605 19.9125 16.6925 19.8708 16.7592 19.8042C17.2133 19.3542 18.2258 18.3417 19.1217 17.4458L20.6592 15.9125C20.7758 15.7958 20.8258 15.6708 20.8258 15.4833C20.8258 13.5542 20.8258 8.95833 20.8258 6.39167L20.8217 6.39583Z"
                  fill="black"
                />
              </g>
              <defs>
                <clipPath id="clip0_1079_33006">
                  <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="translate(0.955002)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="col-8 d-flex flex-column justify-content-center pt-2">
            <div class="card-counter">{{ $t("finishDate") }}</div>
            <div class="card-title">
              {{ formatDateToBR(details.usuario_recebimento_material_data) }}
            </div>
          </div>
        </div>
        <div class="card-widget">
          <div class="img-border">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1079_33016)">
                <path
                  d="M8.53333 13.3625C5.80417 13.3625 3.4125 14.6167 2.07083 16.5C1.12917 17.8167 1.82083 20.0042 3.18333 20.0042H13.8833C15.2458 20.0042 15.9333 17.8209 14.9958 16.5C13.6542 14.6167 11.2625 13.3625 8.53333 13.3625Z"
                  fill="#BEDB74"
                />
                <path
                  d="M12.8333 5.74998C14.2647 5.74998 15.425 4.58965 15.425 3.15832C15.425 1.72698 14.2647 0.56665 12.8333 0.56665C11.402 0.56665 10.2417 1.72698 10.2417 3.15832C10.2417 4.58965 11.402 5.74998 12.8333 5.74998Z"
                  fill="#A47AA9"
                />
                <path
                  d="M17.7125 8.28338C18.7833 5.61672 18.2292 3.87088 18.2042 3.79588C18.1667 3.68338 18.0625 3.61255 17.9417 3.61255C17.9292 3.61255 17.9208 3.61255 17.9083 3.61255C17.8917 3.61255 17.8708 3.62088 17.8542 3.62505C17.7083 3.67505 17.625 3.83338 17.675 3.98338C17.725 4.15422 18.1333 5.72505 17.1917 8.07505C17.1625 8.14588 17.1625 8.22088 17.1917 8.29172C17.2208 8.36255 17.275 8.41255 17.3458 8.44172C17.4083 8.47088 17.4833 8.46672 17.5542 8.44172C17.625 8.41255 17.6833 8.35422 17.7083 8.28755L17.7125 8.28338Z"
                  fill="black"
                />
                <path
                  d="M14.3208 15.825C14.4625 15.825 14.6042 15.775 14.7083 15.6708L16.3167 14.0625C16.4083 13.9708 16.4083 13.8167 16.3167 13.725C16.2708 13.6792 16.2125 13.6542 16.1458 13.6542C16.0792 13.6542 16.0208 13.6792 15.9792 13.725L14.425 15.2792C14.3667 15.3375 14.275 15.3375 14.2167 15.2792L13.5042 14.5625C13.4625 14.5208 13.4 14.4958 13.3333 14.4958C13.2667 14.4958 13.2083 14.5208 13.1667 14.5625C13.075 14.6542 13.075 14.8083 13.1667 14.9L13.9333 15.6708C14.0375 15.775 14.1792 15.825 14.3208 15.825Z"
                  fill="black"
                />
                <path
                  d="M13.6458 18.2833C13.075 18.1666 12.6625 17.7291 12.6583 17.725C12.5667 17.6291 12.3875 17.6208 12.2875 17.7125C12.2375 17.7625 12.2042 17.825 12.2042 17.8916C12.2042 17.9625 12.225 18.0291 12.275 18.0833C12.3292 18.1416 12.825 18.65 13.5417 18.8C13.5583 18.8 13.5708 18.8 13.5875 18.8C13.7083 18.8 13.825 18.7125 13.85 18.5916C13.8792 18.45 13.7875 18.3125 13.6458 18.2833Z"
                  fill="black"
                />
                <path
                  d="M17.9042 11.6C17.1083 10.7625 15.9917 10.2625 14.8333 10.225C14.7208 10.225 14.6042 10.2292 14.4708 10.2417C14.3333 10.2542 14.1917 10.2667 14.0542 10.2875C13.7833 10.3375 13.5292 10.4083 13.2833 10.4917C13.1833 10.4583 13.0875 10.425 12.9833 10.3958L11.9333 10.1042L12.8625 9.53333C14.3917 8.59583 15.3042 6.97083 15.3042 5.19166C15.3083 2.37916 13.0208 0.0958252 10.2125 0.0958252C7.40417 0.0958252 5.1125 2.37916 5.1125 5.19166C5.1125 6.99166 6.0875 8.67916 7.65417 9.59166L8.62083 10.1542L7.54583 10.4583C5.48333 11.0458 4.02083 12.1333 3.19167 13.6958C2.94583 14.1292 2.69583 14.875 2.76667 15.6708C2.825 16.3208 3.09583 17.0042 3.75833 17.5792C4.39167 18.1292 5.27083 18.4333 6.225 18.4333H10.9333C11.0875 18.4333 11.2167 18.3083 11.2167 18.15C11.2167 17.9917 11.0917 17.8667 10.9333 17.8667H6.225C5.40417 17.8667 4.65833 17.6125 4.125 17.15C3.4 16.5208 3.2625 15.775 3.32083 15.1583C3.37917 14.5458 3.625 14.0667 3.67917 13.9708C4.3625 12.6792 5.625 11.6917 7.33333 11.1167C8.45417 10.7375 9.58333 10.6042 10.2125 10.6042C10.2458 10.6042 10.275 10.6042 10.3042 10.6042H10.3292C11.1208 10.6042 11.8333 10.6958 12.475 10.85C11.6458 11.3375 11.0333 12.0833 10.6542 13.0917C10.0708 14.6292 10.325 16.0792 11.4083 17.4125C11.4292 17.4375 11.4583 17.4708 11.4875 17.4958C11.6417 17.6083 11.7625 17.5583 11.8375 17.4958C11.9458 17.4 11.9667 17.275 11.8958 17.1542C11.8667 17.1042 11.8292 17.0625 11.7958 17.0208L11.7583 16.975C11.2458 16.3417 10.9625 15.6083 10.9208 14.8C10.8583 13.6708 11.3 12.5792 12.1375 11.8042C12.85 11.1417 13.775 10.775 14.7417 10.775C14.9042 10.775 15.0667 10.7833 15.225 10.8042C16.8958 11.0167 18.2167 12.3 18.5167 13.9917C18.7958 15.5833 17.9667 17.225 16.5 17.9875C15.9708 18.2625 15.4 18.4042 14.8125 18.4167C14.5958 18.4167 14.475 18.5208 14.4708 18.6917C14.4708 18.7708 14.4917 18.8333 14.5417 18.8792C14.5958 18.9333 14.6875 18.9625 14.8042 18.9625H14.8292C14.9958 18.9583 15.15 18.9458 15.3 18.9292C16.3083 18.8 17.2458 18.3167 17.9458 17.5625C18.6458 16.8083 19.0583 15.8375 19.1125 14.8208C19.175 13.625 18.7458 12.4792 17.9125 11.5958L17.9042 11.6ZM10.2083 9.72499C7.70833 9.72499 5.675 7.69166 5.675 5.19166C5.675 2.69166 7.70833 0.658325 10.2125 0.658325C12.7167 0.658325 14.7458 2.69166 14.7458 5.19166C14.7458 7.69166 12.7125 9.72499 10.2125 9.72499H10.2083Z"
                  fill="black"
                />
              </g>
              <defs>
                <clipPath id="clip0_1079_33016">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="col-8 d-flex flex-column justify-content-center pt-2">
            <div class="card-counter">{{ $t("executor") }}</div>
            <div class="card-title">{{ details.usuario_nome }}</div>
          </div>
        </div>
        <div class="card-widget">
          <div class="img-border">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.65 16.2291H8.22917C7.39154 16.2291 6.7125 16.9082 6.7125 17.7458C6.7125 18.5834 7.39154 19.2625 8.22917 19.2625H12.65C13.4876 19.2625 14.1667 18.5834 14.1667 17.7458C14.1667 16.9082 13.4876 16.2291 12.65 16.2291Z"
                fill="#BEDB74"
              />
              <path
                d="M11.6667 9.56252C13.549 9.56252 15.075 8.03655 15.075 6.15418C15.075 4.27181 13.549 2.74585 11.6667 2.74585C9.78429 2.74585 8.25833 4.27181 8.25833 6.15418C8.25833 8.03655 9.78429 9.56252 11.6667 9.56252Z"
                fill="#A47AA9"
              />
              <path
                d="M17.3667 6.75417C17.2286 5.79003 16.8962 4.86396 16.3896 4.03206C15.8831 3.20016 15.2129 2.47975 14.4198 1.91449C13.6266 1.34922 12.7269 0.950854 11.7753 0.743528C10.8236 0.536203 9.83976 0.524231 8.88333 0.708339C7.71352 0.924739 6.61662 1.43094 5.69293 2.18067C4.76924 2.9304 4.04823 3.89972 3.59584 5.00001C3.12977 6.09209 2.94469 7.28353 3.0575 8.46554C3.17032 9.64755 3.57743 10.7825 4.24167 11.7667C5.1136 13.0356 6.07581 14.2401 7.12084 15.3708C7.49167 15.7875 7.87084 16.1708 8.27084 16.5833C8.44584 16.7722 8.625 16.9597 8.80833 17.1458L8.84167 17.1833H6.13334C6.06772 17.1865 6.00579 17.2146 5.96012 17.2618C5.91445 17.309 5.88848 17.3718 5.8875 17.4375C5.88524 17.5064 5.91019 17.5735 5.95697 17.6242C6.00376 17.6749 6.06861 17.7051 6.1375 17.7083H14.3375C14.4035 17.702 14.4643 17.6701 14.5072 17.6195C14.55 17.5689 14.5713 17.5036 14.5667 17.4375C14.5679 17.3744 14.5448 17.3132 14.5021 17.2667C14.4594 17.2201 14.4005 17.1918 14.3375 17.1875C14.2918 17.1832 14.2457 17.1832 14.2 17.1875H13.1458C12.1931 17.1875 11.2417 17.1875 10.2917 17.1875C10.0828 17.1895 9.87555 17.1497 9.68232 17.0702C9.48908 16.9908 9.31374 16.8734 9.16667 16.725C7.5608 15.1747 6.09923 13.4817 4.8 11.6667C4.25928 10.9333 3.87986 10.0938 3.68668 9.20328C3.49351 8.31281 3.49095 7.39154 3.67917 6.50001C3.94807 5.03562 4.69943 3.70339 5.81349 2.71567C6.92754 1.72794 8.34018 1.14157 9.82623 1.05001C11.3123 0.958446 12.7862 1.36697 14.0131 2.21047C15.24 3.05396 16.1492 4.28387 16.5958 5.70417C16.9386 6.70705 17.0328 7.77816 16.8702 8.82546C16.7076 9.87275 16.2932 10.8649 15.6625 11.7167C14.6071 13.1848 13.4501 14.5771 12.2 15.8833L12.1708 15.9125C12.1263 15.9548 12.0871 16.0024 12.0542 16.0542C12.0227 16.1035 12.0089 16.1622 12.0151 16.2204C12.0213 16.2786 12.0471 16.333 12.0882 16.3747C12.1294 16.4163 12.1835 16.4428 12.2417 16.4496C12.2998 16.4565 12.3586 16.4434 12.4083 16.4125C12.4548 16.3824 12.4969 16.3459 12.5333 16.3042C13.8315 14.9613 15.0265 13.5225 16.1083 12C16.6557 11.2528 17.0488 10.4042 17.2648 9.50358C17.4809 8.60295 17.5155 7.66832 17.3667 6.75417Z"
                fill="black"
              />
              <path
                d="M10.3 12.1375H10.3208C10.4783 12.1353 10.6355 12.1242 10.7917 12.1042C11.5876 12.0037 12.3401 11.6843 12.9652 11.1815C13.5903 10.6786 14.0636 10.0121 14.3322 9.25618C14.6009 8.50024 14.6545 7.68456 14.4869 6.89999C14.3194 6.11542 13.9373 5.39276 13.3833 4.8125C12.9753 4.38185 12.4845 4.03807 11.9403 3.80179C11.3962 3.56551 10.8099 3.4416 10.2167 3.4375L10 3.45833C9.85041 3.4647 9.70145 3.4814 9.55417 3.50833C8.78593 3.61339 8.06225 3.93073 7.46453 4.42466C6.86682 4.91858 6.41878 5.56949 6.17083 6.30417C5.87899 7.01532 5.79339 7.7943 5.92382 8.55185C6.05426 9.30941 6.39546 10.0149 6.90833 10.5875C6.93143 10.6195 6.95798 10.6488 6.9875 10.675C7.03382 10.7184 7.09489 10.7425 7.15833 10.7425C7.22178 10.7425 7.28285 10.7184 7.32917 10.675C7.37965 10.6383 7.41363 10.5831 7.42377 10.5215C7.43391 10.4599 7.41938 10.3968 7.38333 10.3458C7.35338 10.299 7.31995 10.2544 7.28333 10.2125L7.24583 10.1667C6.74276 9.55096 6.45065 8.79001 6.4125 7.99583C6.37593 7.31102 6.52455 6.629 6.84274 6.02149C7.16093 5.41398 7.63693 4.90342 8.22069 4.54351C8.80444 4.18359 9.47439 3.98762 10.1601 3.97618C10.8458 3.96474 11.5219 4.13827 12.1173 4.47852C12.7128 4.81877 13.2055 5.31317 13.5438 5.90973C13.8821 6.50629 14.0533 7.18297 14.0396 7.86863C14.0259 8.55428 13.8277 9.22358 13.4659 9.80614C13.104 10.3887 12.5919 10.863 11.9833 11.1792C11.4675 11.4452 10.897 11.5878 10.3167 11.5958C10.1042 11.5958 9.98333 11.6958 9.98333 11.8625C9.98116 11.8954 9.98598 11.9283 9.99747 11.9592C10.009 11.9901 10.0269 12.0182 10.05 12.0417C10.1176 12.1051 10.2073 12.1395 10.3 12.1375Z"
                fill="black"
              />
              <path
                d="M7.75417 11.25C8.10322 11.6028 8.54303 11.8523 9.025 11.9708C9.09565 11.9844 9.1688 11.9697 9.22878 11.93C9.28876 11.8903 9.33078 11.8287 9.34583 11.7583C9.35952 11.6871 9.345 11.6135 9.30535 11.5528C9.26569 11.4922 9.20401 11.4493 9.13333 11.4333C8.7623 11.3419 8.42356 11.1502 8.15417 10.8791C8.12889 10.8513 8.098 10.8291 8.06353 10.814C8.02906 10.7989 7.99179 10.7913 7.95417 10.7916C7.92018 10.7915 7.88649 10.798 7.85503 10.8109C7.82357 10.8237 7.79496 10.8427 7.77083 10.8666C7.74451 10.8907 7.7232 10.9197 7.70811 10.952C7.69302 10.9843 7.68446 11.0192 7.68291 11.0548C7.68136 11.0905 7.68686 11.126 7.69909 11.1595C7.71132 11.193 7.73003 11.2237 7.75417 11.25Z"
                fill="black"
              />
            </svg>
          </div>
          <div class="col-8 d-flex flex-column justify-content-center pt-2">
            <div class="card-counter">{{ $t("keepingSector") }}</div>
            <div class="card-title">{{ details.zeladoria_nome }}</div>
          </div>
        </div>
      </div>
      <div class="map">
        <div class="map-container">
          <div class="d-flex justify-content-between align-items-center pl-4">
            <div>
              <p class="map-title">{{ $t("location") }}</p>
            </div>
            <Button
              class="mr-4 h-50"
              size="small"
              name="Centralizar"
              @clicked="fitBoundsGoogle"
            />
          </div>
          <div class="mt-3 pb-4 pr-4 pl-4">
            <GmapMap
              ref="googleMap"
              :center="center"
              :zoom="zoom"
              style="height: 278px; width: 100%; position: relative"
              :options="{
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: true,
                mapTypeId: mapType,
                gestureHandling: 'greedy',
                fullscreenControl: false,
                disableDefaultUi: true,
                mapTypeId: mapType,
              }"
            >
              <GmapCustomMarker
                class="markerGoogle"
                :clickable="true"
                :draggable="false"
                :marker="{
                  lat: details.usuario_recebimento_material_latlng.y,
                  lng: details.usuario_recebimento_material_latlng.x,
                }"
              >
                <div class="pinMarker"></div>
              </GmapCustomMarker>
            </GmapMap>
            <div class="mapTypeControllers">
              <CSelect
                placeholder="Tipo"
                :options="mapTypes"
                :value.sync="mapType"
              ></CSelect>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="execution-timeline">
      <div>
        <div class="divisor"></div>
        <p class="timeline-title">{{ $t("timeline") }}</p>
      </div>
      <div class="cards">
        <div v-for="(image, imageIndex) in photo" :key="imageIndex">
          <div class="timeline-card">
            <img
              @click="index = imageIndex"
              :src="image"
              width="100%"
              height="100%"
              class="galeriaClick"
              alt=""
            />
            <div class="timeline-card-content">
              <div class="content-date">
                {{ formatDateToBR(details.usuario_recebimento_material_data) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <CoolLightBox :items="photo" :index="index" @close="index = null" />
    </div>
  </div>
</template>

<script>
import GmapCustomMarker from "vue2-gmap-custom-marker";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

import Button from "../../components/Button.vue";
import BackArrow from "../../components/BackArrow.vue";

import services from "../../services";

export default {
  name: "DetailsTraining",
  components: {
    CoolLightBox,
    GmapCustomMarker,
    BackArrow,
    Button,
  },
  data() {
    return {
      zoom: 4,
      center: {
        lat: -15.288423,
        lng: -49.851561,
      },
      bounds: [],
      details: {
        usuario: {},
        usuario_recebimento_material_latlng: {
          x: 0,
          y: 0,
        },
      },
      photo: [],
      index: null,
      userId: this.$route.params.execucao_uuid,
      mapTypes: [
        { label: this.$t("roadmap"), value: "roadmap" },
        { label: this.$t("sattellite"), value: "satellite" },
        { label: this.$t("hybrid"), value: "hybrid" },
        { label: this.$t("roadmap"), value: "terrain" },
      ],
      mapType: "satellite",
    };
  },
  mounted: async function () {
    this.userId = this.$route.params.user_id;
    await this.initUserData();
  },
  methods: {
    async initUserData() {
      const { data, errors } = await services.users.getUserTrainingDetails({
        usuario_id: this.userId,
      });
      if (!errors) {
        this.details = data[0];
        this.center = {
          lat: this.details.usuario_recebimento_material_latlng.y,
          lng: this.details.usuario_recebimento_material_latlng.x,
        };
        this.photo = [this.details.usuario_recebimento_material_foto];
        this.fitBoundsGoogle();
      }
    },
    fitBoundsGoogle() {
      setTimeout(() => {
        this.$refs.googleMap.$mapPromise.then(() => {
          const b = new window.google.maps.LatLngBounds();
          b.extend({
            lat: this.center.lat,
            lng: this.center.lng,
          });
          this.$refs.googleMap.fitBounds(b);
        });
      }, 100);
    },
    formatDateToBR(date) {
      if (date) {
        let dateFormat = date.split("T");
        let dateSplit = dateFormat[0].split("-");
        let timeSplit = dateFormat[1].split(":");
        let dateBR =
          dateSplit[2] +
          "/" +
          dateSplit[1] +
          "/" +
          dateSplit[0] +
          " " +
          timeSplit[0] +
          ":" +
          timeSplit[1];
        return dateBR;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.details-execution {
  .details-info {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(509px, 1fr));
    align-items: center;
    grid-template-rows: 1fr;
    gap: 20px;
    .details-numbers {
      height: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 24px;

      .card-widget {
        display: flex;
        flex: 1;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        border: 1px solid #c6c9d0;
        border-radius: 16px;
        padding: 28px 18px;
        min-width: 330px;
        min-height: 98px;

        .card-counter {
          font-family: "Montserrat";
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          color: #565e73;
        }

        .card-title {
          font-family: "OpenSans-Regular";
          font-weight: 400;
          font-size: 18px;
          line-height: 32px;
          color: #29334e;
          margin: 0;
          padding: 0;
        }
        .img-border {
          border-radius: 50%;
          border: 1px solid #c6c9d0;
          padding: 8px;
        }
      }
    }

    .map {
      position: relative;

      .mapTypeControllers {
        position: absolute;
        top: 90px;
        left: 50px;
        z-index: 500;
        width: 120px;
      }

      .map-container {
        border-radius: 16px;
        border: 1px solid #dddee3;
        padding: 16px;
      }

      .map-title {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #565e73;
        margin-top: 8px;
      }
    }
  }
}

.widget-fixed {
  height: 100px;
  border: 1px solid red;
}

.colored {
  color: #8ddfb6;
}

.galeriaClick {
  max-width: 192px;
  &:hover {
    cursor: pointer;
    opacity: 0.9;
  }

  border-radius: 8px 8px 0px 0px;
}

.conteudoslide {
  max-width: 535px;
  overflow: hidden;

  img {
    height: 350px;
    margin: 0 auto;
    display: block;

    &:hover {
      cursor: pointer;
    }
  }
}

.popup-marker {
  width: fit-content;
  padding: 12px;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(-45deg);

  .card-pin {
    padding: 0;
    margin: 0;
  }
}

.divisor {
  border-bottom: 1px solid #dddee3;
  margin-bottom: 20px;
  width: 100%;
}

.execution-timeline {
  margin-top: 32px;
  margin-left: 16px;

  .timeline-title {
    font-family: "OpenSans-Regular";
    font-weight: 600;
    font-size: 20px;
    line-height: 132%;
    color: #565e73;
    margin: 0;
    margin-bottom: 32px;
    margin-top: 16px;
  }

  .cards {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 24px;
    padding-top: 0;
    margin-bottom: 24px;

    .timeline-card {
      border-radius: 8px;
      box-shadow: 0px 4px 4px rgba(160, 168, 189, 0.24);
      border-radius: 8px;
      max-width: fit-content;
      height: 100%;
      margin: 10px 0;

      .timeline-card-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 24px 16px;
        gap: 12px;
        height: 100%;
      }

      .galeriaClick {
        max-width: 286px;
        width: 286px;

        &:hover {
          cursor: pointer;
          opacity: 0.9;
        }

        border-radius: 8px 8px 0px 0px;
      }

      .content-tag {
        background: #dddee3;
        border-radius: 4px;
        padding: 2px 4px;
        color: #565e73;
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
        line-height: 156%;
      }

      .content-date {
        font-family: "OpenSans-Regular";
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #838998;
      }
    }
  }
}

.markerGoogle {
  &:hover {
    cursor: pointer;
  }

  .pinMarker {
    position: relative;
    width: 20px;
    height: 20px;
    border-radius: 50% 50% 0 50%;
    background: #422064;
    border: 1px solid #422064;
    transform: rotate(45deg);
  }

  .pinMarkerSelected {
    position: relative;
    width: 20px;
    height: 20px;
    border-radius: 50% 50% 0 50%;
    background: green;
    border: 1px solid green;
    transform: rotate(45deg);
  }
}
.mapTypeControllers {
  position: absolute;
  top: 100px;
  left: 70px;
  z-index: 500;
  width: 120px;
}
</style>
